<form
  class="onboarding-input"
  [formGroup]="bpFormGroup"
  [ngSwitch]="type"
  [class.hasFocus]="colorsSwitcher"
  [class.hasValue]="!!bpFormControlName.value && colorsSwitcher"
>
  <ion-input
    *ngSwitchDefault
    [class.passwordType]="type === 'password'"
    [formControl]="bpFormControlName"
    [type]="type === 'password' ? passwordType : type"
    [placeholder]="placeholder"
    [minlength]="bpFormControlMinLength"
    [maxlength]="bpFormControlMaxLength"
    (ionChange)="ionChange.emit($event)"
    (ionFocus)="onFocus()"
    (ionBlur)="onBlur()"
  >
  </ion-input>

  <ion-datetime
    *ngSwitchCase="'date'"
    mode="ios"
    [formControl]="bpFormControlName"
    (ionChange)="ionChange.emit($event)"
    [max]="getMax(constraints[1])"
    [min]="getMin(constraints[1])"
  >
  </ion-datetime>
  <div *ngSwitchCase="'onboarding-birthdate'" class="reset-birthdate">
    <ion-input
      id="resetbirthdate"
      class="ion-text-start"
      [formControl]="bpFormControlName"
      [placeholder]="placeholder"
      readonly="true"
    ></ion-input>
    <ion-modal trigger="resetbirthdate" size="cover" alignment="center">
      <ng-template>
        <ion-content>
          <ion-datetime
            #birthdatepicker
            [presentation]="pickerType"
            mode="ios"
            [locale]="userLocale"
            [value]="pickerCurrentDate"
            [cancelText]="'CANCEL' | translate"
            [doneText]="'OK' | translate"
            showDefaultButtons="true"
            (ionChange)="onDateChange(birthdatepicker.value)"
          >
          </ion-datetime>
        </ion-content>
      </ng-template>
    </ion-modal>
  </div>

  <span
    class="switchPasswordButton"
    (click)="switchPassword()"
    [hidden]="type !== 'password'"
    bpAddRtlClass
  >
    <ion-icon [name]="passwordIcon"> </ion-icon>
  </span>

  <ion-button
    *ngIf="biometricType"
    class="biometricButton"
    fill="clear"
    shape="round"
    size="small"
    tabindex="-1"
    (click)="onBiometricClick($event)"
    (mousedown)="$event.preventDefault()"
    [attr.aria-label]="
      biometricType === 'face'
        ? ('BIOMETRIC.FACE_ID_LOGIN_TITLE' | translate)
        : biometricType === 'finger'
        ? ('BIOMETRIC.TOUCH_ID_LOGIN_TITLE' | translate)
        : ('BIOMETRIC.BIOMETRIC_LOGIN_TITLE' | translate)
    "
    bpAddRtlClass
  >
    <ion-icon
      *ngIf="biometricType !== 'face'"
      name="finger-print-outline"
    ></ion-icon>
    <svg
      *ngIf="biometricType === 'face'"
      class="biometric-face-icon"
      width="22"
      height="22"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M3.08571 16.4571V9.77143C3.08571 5.99495 5.99495 3.08571 9.77143 3.08571H16.4571C17.3092 3.08571 18 2.39495 18 1.54286C18 0.690761 17.3092 0 16.4571 0H9.77143C4.29076 0 0 4.29076 0 9.77143V16.4571C0 17.3092 0.690761 18 1.54286 18C2.39495 18 3.08571 17.3092 3.08571 16.4571Z"
        fill="currentColor"
      />
      <path
        d="M56.9143 16.4571V9.77143C56.9143 5.99495 54.005 3.08571 50.2286 3.08571H43.5429C42.6908 3.08571 42 2.39495 42 1.54286C42 0.690761 42.6908 0 43.5429 0H50.2286C55.7092 0 60 4.29076 60 9.77143V16.4571C60 17.3092 59.3092 18 58.4571 18C57.605 18 56.9143 17.3092 56.9143 16.4571Z"
        fill="currentColor"
      />
      <path
        d="M3.08571 43.5429V50.2286C3.08571 54.005 5.99495 56.9143 9.77143 56.9143H16.4571C17.3092 56.9143 18 57.605 18 58.4571C18 59.3092 17.3092 60 16.4571 60H9.77143C4.29076 60 0 55.7092 0 50.2286V43.5429C0 42.6908 0.690761 42 1.54286 42C2.39495 42 3.08571 42.6908 3.08571 43.5429Z"
        fill="currentColor"
      />
      <path
        d="M56.9143 43.5429V50.2286C56.9143 54.005 54.005 56.9143 50.2286 56.9143H43.5429C42.6908 56.9143 42 57.605 42 58.4571C42 59.3092 42.6908 60 43.5429 60H50.2286C55.7092 60 60 55.7092 60 50.2286V43.5429C60 42.6908 59.3092 42 58.4571 42C57.605 42 56.9143 42.6908 56.9143 43.5429Z"
        fill="currentColor"
      />
      <path
        d="M16.3158 22.6599V26.948C16.3158 27.8356 16.9874 28.5552 17.8158 28.5552C18.6442 28.5552 19.3158 27.8356 19.3158 26.948V22.6599C19.3158 21.7723 18.6442 21.0527 17.8158 21.0527C16.9874 21.0527 16.3158 21.7723 16.3158 22.6599Z"
        fill="currentColor"
      />
      <path
        d="M41.0526 22.6599V26.948C41.0526 27.8356 41.7242 28.5552 42.5526 28.5552C43.3811 28.5552 44.0526 27.8356 44.0526 26.948V22.6599C44.0526 21.7723 43.3811 21.0527 42.5526 21.0527C41.7242 21.0527 41.0526 21.7723 41.0526 22.6599Z"
        fill="currentColor"
      />
      <path
        d="M19.449 44.3124C22.3748 47.0432 25.9184 48.4212 30 48.4212C34.0816 48.4212 37.6252 47.0432 40.551 44.3124C41.1885 43.7174 41.223 42.7182 40.628 42.0807C40.033 41.4432 39.0338 41.4088 38.3963 42.0038C36.059 44.1852 33.2868 45.2633 30 45.2633C26.7132 45.2633 23.941 44.1852 21.6037 42.0038C20.9662 41.4088 19.967 41.4432 19.372 42.0807C18.777 42.7182 18.8115 43.7174 19.449 44.3124Z"
        fill="currentColor"
      />
      <path
        d="M30 22.6317V33.6843C30 34.3916 29.6543 34.7369 28.9435 34.7369H27.8947C27.0227 34.7369 26.3158 35.4439 26.3158 36.3159C26.3158 37.1879 27.0227 37.8948 27.8947 37.8948H28.9435C31.3975 37.8948 33.1579 36.1365 33.1579 33.6843V22.6317C33.1579 21.7597 32.451 21.0527 31.579 21.0527C30.7069 21.0527 30 21.7597 30 22.6317Z"
        fill="currentColor"
      />
    </svg>
  </ion-button>
</form>
